import React from 'react'

class Notifications extends React.Component
{
    render() {
        return(
            <div className='noti-icon'>

            </div>
        )
    }
}


export default Notifications


// WEBPACK FOOTER //
// ./src/components/Navigation/Notifications.js